import _ from 'lodash'

const findWork = (works, path) => {
  let prevWork, nextWork
  let foundIndex = -1;
  _.forEach(works, (work, index) => {
    if(work.path === path) {
      foundIndex = index;
    }
  });
  if(foundIndex > -1) {
    let work = works[foundIndex];
    if(foundIndex - 1 >= 0){
      work.previousWork = works[foundIndex - 1];
    }
    if(foundIndex + 1 < works.length){
      work.nextWork = works[foundIndex + 1];
    }
    return work;
  } 
}

export default {
  findWork: findWork
};


/** WEBPACK FOOTER **
 ** ../data/works-helper.js
 **/